import { useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import { CustomizeMusic, MusicTitle } from "../../../../Constants/Constants";
import { SongsListData } from "../../../../Data/Messenger/Messenger";
import CommonHeading from "../Common/CommonHeading";

const Music = () => {
  const [currIndex, setCurrIndex] = useState(0);
  const currentSong = SongsListData[currIndex];
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  const strokeDasharray = (currentTime / duration) * 600;

  const handleNext = () => setCurrIndex((prevIndex) => (prevIndex + 1) % SongsListData.length);
  const handlePrevious = () => setCurrIndex((prevIndex) => (prevIndex - 1 + SongsListData.length) % SongsListData.length);
  const handleListen = (e: Event) => {
    const audio = e.currentTarget as HTMLAudioElement;
    setCurrentTime(audio.currentTime);
    setDuration(audio.duration);
  };
  const handleLoadedMetadata = (e: Event) => {
    const audio = e.currentTarget as HTMLAudioElement;
    setDuration(audio.duration);
  };
  const handleVolumeChange = (e: Event) => {
    const audio = e.currentTarget as HTMLAudioElement;
    setVolume(audio.volume);
  };
  return (
    <div className="reminder-main">
      <CommonHeading title={MusicTitle} sunTitle={CustomizeMusic} />
      <div className="player-box">
        <div className="main-wrapper">
          <div className="song-wrapper">
            <div className="song-thumb-wrapper">
              <svg className="song-progress" width={160} height={160} viewBox="0 0 200 200">
                <circle className="song-progress-meter" cx={100} cy={100} r={90} strokeWidth={10} fill="none" />
                <circle className="song-progress-value" cx={100} cy={100} r={90} strokeWidth={10} fill="none" strokeDasharray={`${strokeDasharray} 600`} strokeLinecap="round" />
              </svg>
              <div className="song-thumb" style={{ backgroundImage: `url(${currentSong.thumb})` }} />
            </div>
            <div className="song-info">
              <h2 className="song-info-title">{currentSong.title}</h2>
              <h6 className="song-info-artist">{currentSong.artist}</h6>
            </div>
          </div>
          <AudioPlayer src={currentSong.link} onClickNext={handleNext} onClickPrevious={handlePrevious} showSkipControls showJumpControls={false} onListen={handleListen} onLoadedMetaData={handleLoadedMetadata} volume={volume} onVolumeChange={handleVolumeChange} />
        </div>
      </div>
    </div>
  );
};

export default Music;
